import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { F1StrategyMetadataEditCard } from "./edit_card";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

export const F1StrategyMetadataCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <F1StrategyMetadataEditCard
          id={Number(id)}
          client={Clients.F1_QUANTILIA}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.F1_QUANTILIA}
          audit_table_name={Tables.F1_STRATEGY_METADATA}
        />
      </div>
    </div>
  );
};
